import { render, staticRenderFns } from "./squareButton.vue?vue&type=template&id=372b83da&scoped=true"
import script from "./squareButton.vue?vue&type=script&lang=js"
export * from "./squareButton.vue?vue&type=script&lang=js"
import style0 from "./squareButton.vue?vue&type=style&index=0&id=372b83da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372b83da",
  null
  
)

export default component.exports